<template>
    <form class="booking-confirm" @submit.prevent="confirm">
      <div class="modal-content-generic">
        <div class="content lh-loose">
          <div class="booking-schedule">
              <div class="production-period font-mdish" v-if="data.requested_from != data.requested_to"><strong class="wt-sb">Production Period:</strong> {{ data.date_range_formatted }}</div>
              <div class="production-period font-mdish" v-if="data.requested_from == data.requested_to"><strong class="wt-sb">Production Date:</strong> {{ data.date_range_formatted }}</div>
              <table>
                <tr>
                  <th>Day</th>
                  <th>
                    {{ data.type === 'recce' ? 'Arrival Time' : 'Call Times'}}
                  </th>
                </tr>

                <tr v-for="day in data.days_and_times_formatted">
                  <td>{{ day.day }}</td>
                  <td>{{ day.time }}</td>
                </tr>

                <tr v-if="data.type == 'recce'">
                  <td>Duration of recce</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Brand</td>
                  <td>{{data.hirer_name}}</td> 
                </tr>

                <tr>
                  <td>Production Type</td>
                  <td>{{data.production_type_label}}</td> 
                </tr>

                <tr v-if="data.type != 'recce'">
                  <td>Crew Size</td>
                  <td>{{data.number_of_people}}</td> 
                </tr>

                <tr>
                  <td>Additional Notes</td>
                  <td>{{ data.notes }}</td> 
                </tr>

                <tr>
                  <td>Payout less APS and Merchant Fees</td>
                  <td>{{data.current_quote_total_formatted}}</td> 
                </tr>
              </table>

              <div
                class="form-group vanilla"
                :class="{ 'has-input-error': errors.listerRequirement }"
              >
                <label for="listerRequirement">
                  Is there any additional information that you would like the Hirer to know? eg. No shoes in the house. <br />If you disagree with any of this request, please decline and an Account Manager will contact you.
                  </label
                >
                <textarea
                  id="listerRequirement"
                  v-model="listerRequirement"
                  class="medium"
                ></textarea>
               
              </div>
          </div>
        </div>
      </div>

  
      <div class="modal-actions">
        <div class="action">
          <button type="button" class="button tertiary" @click="$emit('cancel')">
            <svg-icon id="chevronLeft"></svg-icon>
            <span>Cancel</span>
          </button>
        </div>
        <div class="action">
          <loader-button
              type="submit"
              :loading="loading"
              :label="`Confirm ${data.type}`"
              class="button coral"
          ></loader-button>
        </div>
      </div>
    </form>
  </template>
  
  <script>
  import BaseModal from '../../Base'
  
  export default {
    extends: BaseModal,
    props: {
      data: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        reason: null,
        listerRequirement: null,
        errors: {},
        loading: false
      }
    },
    methods: {
      confirm () {
        this.errors = {}
        this.loading = true
        axios.put(`/api/account/bookings/${this.data.id}/currentquoteconfirm`, {listerRequirement: this.listerRequirement})
            .then(() => {
              this.$toasted.show(`Your ${this.data.booking_type_label} has been confirmed.`, { type: 'success' })
              this.reason = null
              this.$emit('confirm')
              this.$eventBus.$emit('update_listing_booking-item')
            })
            .catch(error => {
              this.$toasted.show(
                  `Your ${this.data.booking_type_label} could not be confirmed, please refresh the page and try again.`, {
                    type: 'error'
                  })
            })
            .then(() => {
              this.loading = false
            })
      }
    }
  }
  </script>
  